import { useState } from "react";
import Input from "./ui/Input";

function InputFilterSet({ onChange, initial = "" }: { onChange: (e: string) => void; initial?: string }) {
  // const filter = useGetOneSelect(favoriteFiltersListName, id);

  const [value, setValue] = useState(initial);

  function changeValue(event: React.ChangeEvent<HTMLInputElement>) {
    const data = event.target.value;
    setValue(data);

    onChange(data);
  }

  return <Input value={value} placeholder="Введите название набора" onChange={changeValue} />;
}

export default InputFilterSet;
